import React from "react";
import {IonCol, IonGrid, IonRow, IonButton, IonCheckbox} from "@ionic/react";
import dayjs from "dayjs";
import {Accordion} from "../../../components";

import {useForm, Controller} from "react-hook-form";
import {useHistory} from "react-router";
import {useQuery, useLazyQuery, useMutation} from "@apollo/client";

import {FileUpload} from "../../../components";
import {Breadcrumbs, Input, Select, DatePicker} from "../../../components";
import {REGISTER_MUTATION} from "../../../graphql/mutations/auth.mutation";

import "./register.styles.css";
import toast from "react-hot-toast";
import {ErrorMessage} from "@hookform/error-message";
import {GET_PRIVACY_POLICY} from "../../../graphql/queries/policy.query";
import {yupResolver} from "@hookform/resolvers/yup";

import {
  GET_DYLOG_COMPANY_TYPES,
  GET_DYLOG_DOCUMENT_TYPES,
  GET_DYLOG_PROVINCES,
  GET_DYLOG_FOREIGN_COUNTRIES,
  GET_DYLOG_TYPONYMS,
  GET_DYLOG_MUNICIPALITIES,
} from "../../../graphql/queries/dylog.query";
import registrationSchema from "../../../lib/utils/validations/registration.valiadtion";
import SelectWithSearch from "../../../components/SelectWithSearch";

const Register = () => {
  const history: any = useHistory();

  const historySearch = history?.location?.search;
  const urlParams = new URLSearchParams(historySearch);

  const [uEmail, uFName, uLName] = [
    urlParams.get("email"),
    urlParams.get("firstName"),
    urlParams.get("lastName"),
  ];

  const [clientTypeList, setClientTypeList] = React.useState([]);
  const [documentTypeList, setDocumentTypeList] = React.useState<any[]>([]);

  const [typonymList, setTyponymList] = React.useState<any[]>([]);
  const [provinceList, setProvinceList] = React.useState<any[]>([]);
  const [municpalityList, setMunicipalityList] = React.useState<any[]>([]);
  const [foreignCountryList, setForeignCountryList] = React.useState<any[]>([]);

  const [privacyPolicy, setPrivacyPolicy] = React.useState<any>();
  const [showDocumentWarning, setShowDocumentWarning] =
    React.useState<boolean>(false);

  useQuery(GET_PRIVACY_POLICY, {
    variables: {type: "registration"},
    onCompleted(data) {
      const actualData = data.getPrivacyPolicy.data;
      if (actualData) setPrivacyPolicy(actualData);
    },
  });

  const [registerMutation] = useMutation(REGISTER_MUTATION, {
    onCompleted(data) {
      if (data) {
        if (data?.registerNewAgency?.errors?.[0]) {
          toast.error(data?.registerNewAgency?.errors?.[0]?.message);
        } else {
          toast.success(
            "Registrazione completata con successo. Si prega di controllare l'e-mail per la conferma."
          );
          history.push("/login");
        }
      }
    },
  });

  const [getPaginatedClientType] = useLazyQuery(GET_DYLOG_COMPANY_TYPES, {
    onCompleted(data) {
      if (data) {
        const tempData = data?.getCompanyTypes?.data ?? [];

        setClientTypeList(
          tempData
            ?.filter((itm: any) => itm.id !== ".")
            ?.map((item: any) => ({
              value: item.id,
              display: item.description,
            }))
        );
      }
    },
  });

  useQuery(GET_DYLOG_DOCUMENT_TYPES, {
    onCompleted(data) {
      const actualData =
        data.getDocumentTypes?.data?.map((itm: any) => ({
          value: itm.id,
          display: itm.description,
        })) ?? [];

      setDocumentTypeList(actualData);
    },
  });

  useQuery(GET_DYLOG_MUNICIPALITIES, {
    onCompleted(data) {
      const actualData = data?.getPaginatedMunicipalities?.data ?? [];
      setMunicipalityList(
        actualData.map((itm: any) => ({
          value: itm.id,
          display: itm.description,
        }))
      );
    },
  });

  useQuery(GET_DYLOG_PROVINCES, {
    onCompleted(data) {
      const actualData = data?.getPaginatedProvinces?.data ?? [];
      setProvinceList(
        actualData.map((itm: any) => ({
          value: itm.id,
          display: itm.description,
        }))
      );
    },
  });

  useQuery(GET_DYLOG_FOREIGN_COUNTRIES, {
    onCompleted(data) {
      const actualData = data?.getPaginatedForeignCountries?.data ?? [];
      setForeignCountryList(
        actualData.map((itm: any) => ({
          value: itm.id,
          display: itm.description,
        }))
      );
    },
  });

  useQuery(GET_DYLOG_TYPONYMS, {
    onCompleted(data) {
      const actualData = data?.getPaginatedTyponyms?.data ?? [];
      setTyponymList(
        actualData.map((itm: any) => ({
          value: itm.id,
          display: itm.description,
        }))
      );
    },
  });

  const {
    handleSubmit,
    register,
    setValue,
    getValues,
    control,
    watch,
    clearErrors,

    formState: {errors},
  } = useForm({
    defaultValues: {
      customer: {
        firstName: uFName ?? "",
        lastName: uLName ?? "",
        email: uEmail ?? "",
        mobileNumber: "",
        notifiedBy: ["email"],
        password: "",
        repeatPassword: "",
        acceptedTerms: false,
      },
      agency: {
        name: "",
        firstName: "",
        lastName: "",
        postalCode: "",
        fiscalCode: "",
        documents: [],
        documentNumber: "",
        expiresAt: null,
        documentTypeId: null,
        businessName: "",
        vatNumber: "",
        dylogType: "C",
      },
    },
    resolver: yupResolver(registrationSchema),
  });

  const handleRegister = (data: any) => {
    const agency = data?.agency;
    if (agency.postalCode) {
      data.agency.postalCode = parseInt(data.agency.postalCode);
    }
    if (!data.agency.name) {
      if (data.agency.businessName) {
        data.agency.name = data.agency.businessName;
      } else {
        data.agency.name = `${data.agency.lastName} ${data.agency.firstName}`;
      }
    }

    if (!data.agency.pecEmailAddress) {
      data.agency.pecEmailAddress = data.customer.pecEmail;
    }

    data.agency.regionId = parseInt(data.agency.regionId);
    data.agency.municipalityId = parseInt(data.agency.municipalityId);

    delete data.customer.accountType;

    registerMutation({
      variables: {
        token: "XYZ",
        customer: data.customer,
        agency: data.agency,
      },
    });
  };

  const breadcrumbEntries = [{title: "Registrazione"}];

  React.useEffect(() => {
    getPaginatedClientType({
      variables: {
        field: "name",
        order: "ASC",
        limit: 100,
        offset: 0,
        isCategoryPublic: true,
      },
    });
  }, []);

  const handleShowDocumentExpiryDate = (value: string) => {
    const newDate = new Date();
    if (dayjs(value).isBefore(newDate)) {
      setShowDocumentWarning(true);
    } else {
      setShowDocumentWarning(false);
    }
  };

  const DylogTypeAttribute = [
    {
      value: "C",
      description: "Privato",
    },
    {
      value: "D",
      description: "Ditta Individuale",
    },
    {
      value: "R",
      description: "Società",
    },
  ];

  const watchAccountType = watch("agency.dylogType");

  console.log(watchAccountType, "watchAccountType");

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />
      <div className="app-page-wrapper">
        <form onSubmit={handleSubmit(handleRegister)}>
          <Accordion title="Dati dell’account">
            <IonGrid>
              <IonRow>
                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Nome"}
                    registerName={`customer.firstName`}
                    register={register}
                    errors={errors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Cognome"}
                    registerName={`customer.lastName`}
                    register={register}
                    errors={errors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name="Indirizzo email"
                    registerName={`customer.email`}
                    register={register}
                    errors={errors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name="Password"
                    type="password"
                    registerName={`customer.password`}
                    register={register}
                    errors={errors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name="Conferma password"
                    type="password"
                    registerName={`customer.repeatPassword`}
                    register={register}
                    errors={errors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name="Numero di telefono"
                    registerName={`customer.mobileNumber`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Select
                    name="Ricezione avanzamento ordine"
                    registerName={`customer.notifiedBy`}
                    register={register}
                    errors={errors}
                    multiple
                    options={[
                      {
                        value: "email",
                        display: "Email",
                      },
                      {
                        value: "sms",
                        display: "SMS",
                      },
                    ]}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Select
                    name="Tipo cliente"
                    registerName={`agency.dylogType`}
                    register={register}
                    errors={errors}
                    onChange={(e) => {
                      setValue("agency.dylogType", e.target.value);
                    }}
                    options={DylogTypeAttribute?.map((itm: any) => ({
                      value: itm.value,
                      display: itm.description,
                    }))}
                    required
                  />
                </IonCol>
              </IonRow>
            </IonGrid>
          </Accordion>

          <Accordion title="Fatturazione">
            <IonGrid>
              <IonRow>
                {watchAccountType === "C" && (
                  <>
                    <IonCol size="12" size-sm="4">
                      <Input
                        name={"Nome"}
                        registerName={`agency.firstName`}
                        register={register}
                        errors={errors}
                      />
                    </IonCol>

                    <IonCol size="12" size-sm="4">
                      <Input
                        name="Cognome"
                        registerName={`agency.lastName`}
                        register={register}
                        errors={errors}
                      />
                    </IonCol>
                  </>
                )}

                {watchAccountType !== "C" && (
                  <>
                    <IonCol size="12" size-sm="4">
                      <Input
                        name="Ragione sociale"
                        registerName={`agency.businessName`}
                        register={register}
                        errors={errors}
                      />
                    </IonCol>
                  </>
                )}

                <IonCol size="12" size-sm="4">
                  <Input
                    name="Codice Fiscale"
                    registerName={`agency.fiscalCode`}
                    register={register}
                    errors={errors}
                    type="text"
                  />
                </IonCol>

                {watchAccountType !== "C" && (
                  <IonCol size="12" size-sm="4">
                    <Input
                      name="Partita IVA"
                      registerName={`agency.vatNumber`}
                      register={register}
                      errors={errors}
                    />
                  </IonCol>
                )}

                <IonCol size="12" size-sm="4">
                  <SelectWithSearch
                    name="Toponimo"
                    registerName={`agency.streetId`}
                    register={register}
                    errors={errors}
                    options={typonymList}
                    hasSearch
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    clearErrors={clearErrors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Indirizzo (Via...)"}
                    registerName={`agency.address`}
                    register={register}
                    errors={errors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Numero civico"}
                    registerName={`agency.houseNumber`}
                    register={register}
                    errors={errors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name="Cap"
                    registerName={`agency.postalCode`}
                    register={register}
                    errors={errors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <SelectWithSearch
                    name="Città"
                    registerName={`agency.municipalityId`}
                    register={register}
                    errors={errors}
                    options={municpalityList}
                    hasSearch
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    clearErrors={clearErrors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <SelectWithSearch
                    name="Provincia"
                    registerName={`agency.province`}
                    register={register}
                    errors={errors}
                    options={provinceList}
                    hasSearch
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    clearErrors={clearErrors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <SelectWithSearch
                    name="Stato"
                    registerName={`agency.regionId`}
                    register={register}
                    errors={errors}
                    options={foreignCountryList}
                    hasSearch
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    clearErrors={clearErrors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Pec"}
                    registerName={`agency.pecEmail`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"SDI email"}
                    registerName={`agency.sdiEmail`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Indirizzo Email per fatture"}
                    registerName={`agency.email`}
                    register={register}
                    errors={errors}
                    required
                  />
                </IonCol>
              </IonRow>
            </IonGrid>
          </Accordion>

          {watchAccountType !== "C" && (
            <Accordion title="Dati Rappresentante Legale">
              <IonGrid>
                <IonRow>
                  {/* <IonCol size="12" size-sm="4">
                  <Input
                    name={"Denominazione"}
                    registerName={`agency.name`}
                    register={register}
                    errors={errors}
                  />
                </IonCol> */}

                  <IonCol size="12" size-sm="4">
                    <Input
                      name="Legale rappresentante"
                      registerName={`agency.representative`}
                      register={register}
                      errors={errors}
                    />
                  </IonCol>
                  {/* 
                  <IonCol size="12" size-sm="4">
                    <Select
                      name="Tipo società"
                      registerName={`agency.companyTypeId`}
                      register={register}
                      errors={errors}
                      options={clientTypeList}
                    />
                  </IonCol> */}

                  <IonCol size="12" size-sm="4">
                    <Select
                      name="Tipologia documento"
                      registerName={`agency.documentTypeId`}
                      register={register}
                      errors={errors}
                      options={documentTypeList}
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="4">
                    <Input
                      name="N° documento, del legale rappresentante"
                      registerName={`agency.documentNumber`}
                      register={register}
                      errors={errors}
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="4">
                    <DatePicker
                      name="Scadenza"
                      registerName={`agency.expiresAt`}
                      register={register}
                      control={control}
                      errors={errors}
                      onChange={handleShowDocumentExpiryDate}
                      min={dayjs().subtract(5, "year").format("YYYY-MM-DD")}
                      max={dayjs().add(5, "year").format("YYYY-MM-DD")}
                      style={{
                        width: "100%",
                      }}
                    />

                    {showDocumentWarning && (
                      <div className="app-input-wrapper">
                        <span>attenzione il documento risulta scaduto</span>
                      </div>
                    )}
                  </IonCol>

                  <IonCol size="12" size-sm="4">
                    <FileUpload
                      fieldName="Immagine della carta di identità"
                      form={{
                        registerName: "agency.documents",
                        register,
                        errors,
                        setValue,
                      }}
                    />
                  </IonCol>
                </IonRow>
              </IonGrid>
            </Accordion>
          )}

          {/* <Accordion title="Contatti">
            <IonGrid>
              <IonRow>
                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Pec email"}
                    registerName={`agency.pecEmailAddress`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>
              </IonRow>
            </IonGrid>
          </Accordion> */}

          <div className="register-terms">
            <Controller
              name={`customer.acceptedTerms`}
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Devi accettare la privacy",
                },
              }}
              render={({field}) => {
                return (
                  <IonCheckbox
                    color="primary"
                    slot="start"
                    checked={field.value}
                    onIonChange={(e) => {
                      setValue(`customer.acceptedTerms`, e.detail.checked);
                    }}
                  />
                );
              }}
            />
            <div className="ms-default" style={{fontSize: "14px"}}>
              <div
                dangerouslySetInnerHTML={{
                  __html: privacyPolicy?.footer?.replace(
                    /{{url}}/gi,
                    `${window.location.origin}/privacy-policy/registration`
                  ),
                }}
              />
            </div>
          </div>

          <div className="app-input-wrapper">
            <ErrorMessage
              errors={errors}
              name={`customer.acceptedTerms`}
              as={"span"}
            />
          </div>

          <div className="flex-justify-between mb-default">
            <span />
            <IonButton
              shape="round"
              slot="end"
              size="default"
              className="login-button mb-default"
              type="submit"
            >
              Invia
            </IonButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
